<template>
  <div class="org-container">
    <div class="section-container">
      <p class="main-title">总部与城市公司</p>

      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>HQ</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>地产集团总部</p>
            <P>成都市锦江区金石路366号新希望·中鼎国际大厦2栋23~24F</P>
            <p><br /></p>
            <p><br /></p>
            <p><br /></p>
            <p style="color: black">
              <strong>(以下子公司按城市的拼音字母排序) </strong>
            </p>
          </div>
          <div class="org-text-item">
            <p>物业集团总部</p>
            <p>成都市锦江区金石路366号新希望·中鼎国际大厦2栋16F</p>
          </div>
        </el-col>
      </el-row>

      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>C</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>成都公司</p>
            <p>成都市锦江区金石路366号新希望·中鼎国际大厦2栋15F</p>
            <p>+86 (28) 8074 7588</p>
            <p>newhopecd@newhope.cn</p>
          </div>
          <div class="org-text-item">
            <p>重庆公司</p>
            <p>重庆市渝北区栖霞路18号融创金贸时代南区3幢10F</p>
            <p>+86 (23) 608 48100</p>
            <p>cqzpyxbs@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>D</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>大连公司</p>
            <p>大连市沙河口区西南路497号新希望璞石墅售楼处3F</p>
            <p>+86 (411) 871 1188</p>
            <p>gaocao@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>G</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>广佛公司</p>
            <p>广州市越秀区广州大道中富力新天地中心4702#</p>
            <p>+86 (20) 8700 6407</p>
            <p>liyx4@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>H</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>杭州公司</p>
            <p>杭州市江干区平安金融中心B座2901#</p>
            <p>+86 (571) 8528 0637</p>
            <p>qiankj@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>J</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>嘉兴公司</p>
            <p>嘉兴市南湖区南湖商会大厦A座19F</p>
            <p>+86 (573) 8999 0055</p>
            <p>zhangzhe@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>K</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>昆明公司</p>
            <p>昆明市西山区广福路与希望路交汇处新希望观澜汇营销中心</p>
            <p>+86 (871) 6459 4000</p>
            <p>pujia@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>N</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>宁波公司</p>
            <p>宁波市鄞州区泰安中路508号创意设计大厦16F</p>
            <p>+86 (574) 8812 0628</p>
            <p>shinan@newhope.cn</p>
          </div>
          <div class="org-text-item">
            <p>南宁公司</p>
            <p>南宁市西乡塘区安吉47-2号大商汇建材城A1栋3F</p>
            <p>+86 (771) 310 5290</p>
            <p>nanning@newhope.cn</p>
          </div>
          <div class="org-text-item">
            <p>南京公司</p>
            <p>南京市建邺区金融城1号楼19F</p>
            <p>+86 (25) 6660 9800</p>
            <p>dengyu@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>S</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>沈阳公司</p>
            <p>沈阳市浑南区东陵东路86号紫檀山会所</p>
            <p>+86 (24) 8803 7292</p>
            <p>zhaoyu3@newhope.cn</p>
          </div>
          <div class="org-text-item">
            <p>苏州公司</p>
            <p>苏州市吴江区东太湖大道7070号亨通金融大厦21F</p>
            <p>+86 (512) 6239 7775</p>
            <p>caiff@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>T</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>天津公司</p>
            <p>天津市河西区解放南路海河大观9号楼1816#</p>
            <p>（座机暂无）</p>
            <p>shiyy3@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>W</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>武汉公司</p>
            <p>武汉市硚口区中山大道1号越秀财富中心14F(附加34F)</p>
            <p>（座机暂无）</p>
            <p>linxuan@newhope.cn<br /></p>
          </div>
          <div class="org-text-item">
            <p>温州公司</p>
            <p>温州市永嘉县三江街道立体城写字楼3号楼7F</p>
            <p>+86 (577) 6699 8100</p>
            <p>xxwwz@newhope.cn</p>
          </div>
        </el-col>
      </el-row>
      <el-row
        class="word-list-item wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="6">
          <div class="filter-item">
            <p>X</p>
          </div>
        </el-col>
        <el-col :span="18" class="org-box">
          <div class="org-text-item">
            <p>西安公司</p>
            <p>西安市高新区锦业路12号百尺竿头中心31F-A01室</p>
            <p>+86 (29) 8963 6688</p>
            <div>miqh@newhope.cn</div>
            <p><br /></p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrgPage",
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
      // 手动触发滚动事件
      const event = new Event("scroll");
      window.dispatchEvent(event);
    });
  },
};
</script>
<style lang="scss" scoped>
.org-container {
  .main-title {
    color: #3c4347;
    padding-bottom: 50px;
    padding-top: 90px;
    font-size: 46px;
    line-height: 46px;
  }

  .word-list-item {
    color: #000000;
    border-bottom: 1px dashed #7a7a7a;
  }

  .filter-item {
    height: 110px;

    > p {
      transition: all 0.3s ease-in-out;
      margin-top: 30px;
      color: #3c4347;
      font-size: 84px;
      line-height: 80px;
    }
  }

  .org-box {
    overflow: hidden;

    .org-text-item {
      box-sizing: border-box;
      padding-top: 40px;
      padding-bottom: 40px;
      float: left;
      font-size: 12px;
      color: #565c61;
      line-height: 20px;
      transition: all 0.3s ease-in-out;
      width: 50%;

      > p {
        font-size: 12px;
        color: #565c61;
        line-height: 20px;
        transition: all 0.3s ease-in-out;

        &:first-child {
          font-size: 22px;
          line-height: 22px;
          margin-bottom: 20px;
          color: #3c4347;
          transition: all 0.3s ease-in-out;
        }
        &:nth-child(2) {
          box-sizing: border-box;
          margin-top: 0px;
          margin-bottom: 0px;
          padding: 0px;
        }
      }
    }
  }
}
</style>
